import { Box } from "devextreme-react";
import { Item } from "devextreme-react/box";
import IndividualReportGridLeft from "./IndividualReportGridLeft";
import IndividualReportGridRight from "./IndividualReportGridRight";
import { useEffect, useState } from "react";
import axios from "axios";

export default function IndividualReport() {
  const [projectName, setProjectName] = useState(null);
  // const [divList, setDivList] = useState(null);
  const [yearMonth, setYearMonth] = useState(null);

  const [leftFullScreen, setLeftFullScreen] = useState(false);
  const [rightFullScreen, setRightFullScreen] = useState(false);

  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/workR/individualReport/projectName`
    );

    setProjectName(result.data.name);

    // const result2 = await axios.get(
    //   `${process.env.REACT_APP_BECCO_API_URL}/api/employee/div`
    // );

    // setDivList(result2.data);

    const result2 = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/workR/individualReport/yearMonth`
    );

    setYearMonth(result2.data);
  }, []);

  return (
    <Box direction="row" width={"100%"}>
      <Item ratio={1}>
        <IndividualReportGridLeft
          projectName={projectName}
          yearMonth={yearMonth}
        />
        {/* <IndividualReportGridRight
          projectName={projectName}
          yearMonth={yearMonth}
        /> */}
      </Item>
      <Item ratio={1}>
        <IndividualReportGridRight
          projectName={projectName}
          yearMonth={yearMonth}
        />
      </Item>
    </Box>
    // <div
    //   className={`container${
    //     leftFullScreen || rightFullScreen ? `-full-screen` : ``
    //   }`}
    // >
    //   <div className={`box${leftFullScreen ? `-full-screen` : ``}`}>
    //     <IndividualReportGridRight
    //       fullScreen={leftFullScreen}
    //       setFullScreen={setLeftFullScreen}
    //       projectName={projectName}
    //       yearMonth={yearMonth}
    //     />
    //   </div>
    //   <div className={`box${rightFullScreen ? `-full-screen` : ``}`}>
    //     <IndividualReportGridRight
    //       fullScreen={rightFullScreen}
    //       setFullScreen={setRightFullScreen}
    //       projectName={projectName}
    //       yearMonth={yearMonth}
    //     />
    //   </div>
    // </div>
  );
}
